import React, { useState } from 'react'
import '../App.css'
import axios from 'axios'
import { SERVER_URI } from '../utility/config'
import LoginRequest from './LoginRequest'

function OrderMaxCreatedMessage(props) {
  window.setTimeout(function () {
    // Move to a new location
    props.handleClose()
  }, 1700)
  return (
    <div>
      <h2 className='message_title'>Maksimitilausmäärä asetettu</h2>
    </div>
  )
}

function AddOrderLimit(props) {
  const [show, setShow] = useState(false)
  const [userData, setUserData] = useState({
    orderLimit: '',
  })
  let storage = window.localStorage
  let userToken = storage.getItem('admin_token')

  //Look at this closer

  const onChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value })
  }

  // Submit
  const doSubmit = async (e) => {
    e.preventDefault()
    const dataToServer = {
      ...userData,
      orderLimit: Number(userData.orderLimit),
    }
    try {
      await axios.post(`${SERVER_URI}/set_order_limit/`, dataToServer, {
        headers: { Authorization: `Token ${userToken}` },
      })
      props.dispatch({
        type: 'SET_ORDER_LIMIT',
        data: { setOrderLimit: dataToServer },
      })
      setShow(!show)
    } catch (e) {
      console.log('Error in setting order limit', e)
    }
  }
  return (
    <div className='popUp_card'>
      <div className='popup-box'>
        <div className='box'>
          <span className='close-icon' onClick={props.handleClose}>
            x
          </span>
          {!show && (
            <div>
              <h2 className='popUp_title'>Muuta maksimitilausmäärää </h2>
              <form className='orderLimit_form' onSubmit={(e) => doSubmit(e)}>
                <label className='label_add' htmlFor='orderLimit'>
                  Aseta uusi maksimi:
                </label>
                <input
                  type='number'
                  id='orderLimit'
                  name='orderLimit'
                  onChange={onChange}
                  placeholder='Määrä'
                  min='1'
                  max='5000000000'
                  required
                ></input>{' '}
                kpl<span className='validity'></span>{' '}
                <br className='desktop-break' />
                <input type='submit' id='gradient_Button' value='Muuta' />
              </form>
            </div>
          )}
          {show && <OrderMaxCreatedMessage handleClose={props.handleClose} />}
        </div>
      </div>
    </div>
  )
}

function OrderLimit(props) {
  props.stopListRefresh()
  const [isOpen, setIsOpen] = useState(false)
  //const [isloggedIn, setIsloggedIn] = useState(true);
  //let storage = window.localStorage;
  //let userToken = storage.getItem("admin_token")

  /*  useEffect(() => {
        const fetchLogin = async () => {
            if (userToken === null) {
                console.log("kirjaudu sisään")
                setIsloggedIn(false)
            }
        }
        fetchLogin();
        // DON'T DELETE THE COMMENT BELOW!!
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) */

  const togglePopUp = async () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className='configurations'>
      {isOpen && (
        <AddOrderLimit dispatch={props.dispatch} handleClose={togglePopUp} />
      )}
      <h3>
        Voimassa oleva maksimi-
        <br />
        tilausmäärä hetitilauksille
      </h3>
      <div className='rides'>
        {props.orderLimit === undefined ? (
          <LoginRequest />
        ) : props.orderLimit.length === 0 ? (
          <h4>Ei määrää</h4>
        ) : (
          <div className='customer_list'>
            Maksimimäärä: {props.orderLimit} kpl
            <br />
          </div>
        )}
      </div>
      <button id='gradient_Button' onClick={togglePopUp}>
        Aseta uusi maksimimäärä
      </button>
    </div>
  )
}

export default OrderLimit
